import React from 'react';
import TeamUpDetailsModalContent from '../../Modals/TeamUpDetailsModalContent';
import AreYouSureModal from '../../Modals/AreYouSureModal';
import {useState} from 'react';
import { TuButton, TU_ICON } from 'Components/Professional/Cases/TeamupUI';
import { Svg } from 'Components/Professional/Cases/CaseListUI';


function AttorneyDashboardInfo({
    selected,
    userInfo,
    confirmTeamup,
    deleteTeamup,
    showHoverMsg,
    setShowHoverMsg,
    hoverMessage,
    cardBuilder
}) {
    
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showConfirmModal1, setShowConfirmModal1] = useState(false);
    const [currentObj, setCurrentObj] = useState({inviteId : '', fromUser: ''});
  const isFunder = !!userInfo?.isUserFunder;
  const pending = selected?.inviteStatus === 0;
  const other = isFunder ? selected?.fromUser : selected?.toUser;
  const otherName = `${other?.firstName || ''} ${other?.lastName || ''}`.trim();
  const caseNo = selected?.caseDetails?.caseNumber;
  // funders can accept only once they have access to the full case (conflict cleared)
  const canApprove = selected?.caseStatus === "noConflict";
  const ask = (setter) => { setter(true); setCurrentObj({ inviteId: selected?._id, fromUser: selected?.fromUser?._id }); };
  const banner = isFunder
    ? (pending ? `${otherName} asked to share contact details with you to team up on ${caseNo}.` : `${otherName} can now see your contact details to discuss ${caseNo}.`)
    : (pending ? `You asked ${otherName} to share contact details to team up on ${caseNo}. Waiting for them to accept.` : `You're connected with ${otherName}. You can now see their contact details for ${caseNo}.`);
  const actions = isFunder && pending ? (
    <div className='flex flex-col gap-2 w-full'>
      <div className='flex gap-2.5 flex-wrap'>
        <TuButton icon={TU_ICON.check} disabled={!canApprove} onClick={() => ask(setShowConfirmModal)}>Accept request</TuButton>
        <TuButton variant="secondary" disabled={!canApprove} onClick={() => ask(setShowConfirmModal1)}>Dismiss</TuButton>
      </div>
      {!canApprove && <span className='font-plexsans font-normal text-[12.5px] leading-[1.45] text-navy/[.6]'>{hoverMessage}</span>}
    </div>
  ) : null;
  const panelHead = (title, sub) => (
    <div className='py-3.5 px-5 border-b border-navy/[.1] flex flex-col gap-1'>
      <span className='font-plexsans font-semibold text-[15px] leading-[1.2] text-navy'>{title}</span>
      {sub && <span className='font-plexsans font-normal text-[12.5px] leading-[1.4] text-navy/[.6]'>{sub}</span>}
    </div>
  );
  const panel = 'bg-white border border-navy/[.12] rounded-md overflow-hidden';
  return (
    <div className='font-plexsans flex flex-col gap-4'>
        {
                showConfirmModal &&
                <AreYouSureModal
                    onClose={() => setShowConfirmModal(false)}
                    uploadNew={showConfirmModal}
                    buttonName="Accept"
                    onSubmit={() => {
                        setShowConfirmModal(false);
                        confirmTeamup(currentObj?.inviteId, currentObj?.fromUser)
                    }}
                    text={"Accept this team-up request? The attorney will see your contact details."}
                />
            }
            {
                showConfirmModal1 &&
                <AreYouSureModal
                    onClose={() => setShowConfirmModal1(false)}
                    uploadNew={showConfirmModal1}
                    buttonName="Dismiss"
                    onSubmit={() => {
                         setShowConfirmModal1(false);
                        deleteTeamup(currentObj?.inviteId, currentObj?.fromUser)}}
                    text={"Dismiss this team-up request?"}
                />
            }
        <div className={`flex items-start gap-2.5 py-[13px] px-4 rounded-md font-plexsans font-medium text-[13.5px] leading-[1.45] text-navy border ${pending ? 'bg-brass/[.07] border-brass/[.25]' : 'bg-success/[.07] border-success/[.3]'}`}>
            <span className={`flex-none flex mt-px ${pending ? 'text-brass' : 'text-success'}`}><Svg d={pending ? TU_ICON.clock : TU_ICON.link} size={16} width={2} /></span>
            <span>{banner}</span>
        </div>
        <div className={panel}>
            {panelHead(isFunder ? "Attorney information" : "Funder information",
                isFunder && selected?.fromUserAssistant ? `${selected?.fromUserAssistant.firstName} ${selected?.fromUserAssistant.lastName} sent this request for ${selected?.fromUser?.firstName} ${selected?.fromUser?.lastName}.` : null)}
            {isFunder && selected?.fromUserAssistant ?
                <>
                    <TeamUpDetailsModalContent currentProf={selected?.fromUser} showContact={true} showButtons={false} isModal={false} />
                    <div className='border-t border-navy/[.1]'>
                        <TeamUpDetailsModalContent currentProf={selected?.fromUserAssistant} showContact={true} showButtons={false} isModal={false} />
                    </div>
                    {actions && <div className='pt-3.5 px-5 pb-[18px] border-t border-navy/[.1]'>{actions}</div>}
                </>
                :
                <TeamUpDetailsModalContent
                    currentProf={other}
                    showContact={isFunder ? true : !pending}
                    showButtons={!!actions}
                    buttonDiv={actions}
                    isModal={false} />
            }
        </div>
        <div className='flex flex-col gap-2 pb-6'>
            <span className='font-plexsans font-semibold text-[11px] leading-none tracking-[.08em] uppercase text-navy/[.55]'>The case</span>
            {cardBuilder(selected)}
        </div>
    </div>
  )
}

export default AttorneyDashboardInfo
